export default `{{::$ctrl.defaultFeedbackText}}`;